import { render, staticRenderFns } from "./LoadIdInfo.vue?vue&type=template&id=048fac6a&scoped=true"
import script from "./LoadIdInfo.vue?vue&type=script&lang=js"
export * from "./LoadIdInfo.vue?vue&type=script&lang=js"
import style0 from "./LoadIdInfo.vue?vue&type=style&index=0&id=048fac6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048fac6a",
  null
  
)

export default component.exports